define(function () {
  return /^\s+/;
});